import Navbar from '../Navbar.jsx';
import FigureViewer from './FigureViewer.js';

const ProtoView = () => {
    return (
        <>
            <Navbar/>
            <FigureViewer/>
        </>
    );
};

export default ProtoView;